import { render, staticRenderFns } from "./LeaveTeamModal.vue?vue&type=template&id=b9dd1f94"
import script from "./LeaveTeamModal.vue?vue&type=script&lang=js"
export * from "./LeaveTeamModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports